'use client';
import React, { useEffect, useState } from 'react';
import BottomSheetNoPadding from '@/components/shared/bottom-sheet/bottom-sheet-no-padding.component';

import Typography from '@/components/shared/typography/typography.component';
import Lottie from 'react-lottie';
import * as animationData from '../../../public/Lottie/buttonArrow.json';

import { useTranslation, useWindowDimensions } from '@/hook';
import SylndrButton from '@/components/shared/Button/button-styled.component';
import Link from 'next/link';
import { DownloadAppAnimation } from '../../../public/Images/financing';
import Image from 'next/image';
import { DimensionsTargets } from '@/hook/use-window-width.hook';
import Modal from '@/components/shared/modal.component';
import { APP_STORE_LINK, GOOGLE_PLAY_LINK } from '@/constants';

interface IDownloadAppBottomSheet {
    open: boolean;
    setOpen: (boolean) => void;
}

function DownloadAppBottomSheet({ open, setOpen }: IDownloadAppBottomSheet) {
    const { t } = useTranslation();
    const whyDownloadText = [
        t('whyDownloadText1'),
        t('whyDownloadText2'),
        t('whyDownloadText3'),
    ];
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
        },
    };
    const [storeLink, setStoreLink] = useState<string | null>(null);
    const { IS_DESKTOP } = useWindowDimensions(DimensionsTargets.DESKTOP);
    useEffect(() => {
        const agent = window.navigator.userAgent;

        // iPhone
        const IsIPhone = agent.match(/iPhone/i) != null;

        // Android
        const IsAndroid = agent.match(/Android/i) != null;

        let link;
        if (IsIPhone) {
            link = APP_STORE_LINK;
        } else if (IS_DESKTOP || IsAndroid) {
            link = GOOGLE_PLAY_LINK;
        }
        setStoreLink(link);
    }, []);
    const renderContent = () => {
        return (
            <div>
                <div className={'relative flex flex-col items-center md:p-4 '}>
                    <div
                        className={
                            'h-1 w-20 rounded-full bg-gray-300 z-30 mt-3 md:hidden'
                        }
                    />
                    <div
                        className={
                            ' bg-gradient-primary h-full absolute pointer-events-none top-0 left-0 w-full z-1'
                        }
                    />
                    <div
                        className={
                            'p-4 flex gap-6 flex-col w-full items-center '
                        }
                    >
                        <div className={'overflow-visible  z-10'}>
                            <Image
                                src={DownloadAppAnimation}
                                height={400}
                                width={400}
                                alt={'download-app'}
                            />
                            <div
                                className={
                                    'w-full shadow-[0px_-13px_27.5px_0px_rgba(0,0,0,0.12)] h-1 z-1 bg-white'
                                }
                            />
                        </div>
                        <div
                            className={
                                'flex flex-col items-center z-2 gap-1.5 bg-white'
                            }
                        >
                            <Typography
                                variant={'subtitle2SemiBold'}
                                className={'text-center'}
                            >
                                {t('downloadAppTitle')}
                            </Typography>
                            <Typography
                                variant={'caption'}
                                className={'text-center'}
                            >
                                {t('downloadAppSubtitle')}
                            </Typography>
                        </div>
                    </div>
                    <div
                        className={
                            'flex flex-col bg-gray-50 w-full rounded-t-2xl md:rounded-2xl p-4 pb-8 gap-3 md:p-6  '
                        }
                    >
                        <Typography
                            variant={'captionSemiBold'}
                            className={'text-gray-700 text-center'}
                        >
                            {t('downloadAppWhy')}
                        </Typography>
                        <div className={'flex flex-col gap-1.5 md:flex-row '}>
                            {whyDownloadText.map((text, i) => (
                                <div
                                    className={'flex gap-1 md:w-full'}
                                    key={`why-download-${i}`}
                                >
                                    <Typography
                                        key={`why-download-app-${i}`}
                                        variant={'caption'}
                                        className={'text-gray-600'}
                                    >
                                        &bull;
                                    </Typography>
                                    <Typography
                                        key={`why-download-app-${i}`}
                                        variant={'caption'}
                                        className={'text-gray-600'}
                                    >
                                        {`${text}`}
                                    </Typography>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className={'bg-white p-4 '}>
                    {storeLink && (
                        <Link target={'_blank'} href={storeLink}>
                            <SylndrButton
                                onClick={() => {
                                    //TODO
                                    // ADD ANALYTICS
                                }}
                                variant="primary"
                            >
                                <div className="flex justify-center items-center gap-2 !w-full bg-primary-600 rounded-lg h-12 ">
                                    <Typography
                                        variant="body2Medium"
                                        className="!text-white ar:mt-1"
                                    >
                                        {t('Download Now')}
                                    </Typography>
                                    <div className={'w-5 rtl:-scale-x-100'}>
                                        {/* @ts-ignore */}
                                        <Lottie
                                            options={defaultOptions}
                                            height={20}
                                            width={20}
                                        />
                                    </div>
                                </div>
                            </SylndrButton>
                        </Link>
                    )}
                </div>
            </div>
        );
    };
    return IS_DESKTOP ? (
        <Modal open={open} setOpen={setOpen}>
            {renderContent()}
        </Modal>
    ) : (
        <BottomSheetNoPadding open={open} setOpen={setOpen}>
            {renderContent()}
        </BottomSheetNoPadding>
    );
}

export default DownloadAppBottomSheet;
